require('./lbaRemarksEditor.scss');

const $inject = [];

const lbaRemarksEditor = function () {
    return {
        restrict: 'A',
        scope: {
            settings: '<',
        },
        bindToController: true,
        controller: 'lbaRemarksEditorCtrl',
        controllerAs: 'vm',
        template: require('./lbaRemarksEditor.html'),
    };
};

lbaRemarksEditor.$inject = $inject;

export default lbaRemarksEditor;



// WEBPACK FOOTER //
// ./src/components/lbaRemarksEditor/lbaRemarksEditorDir.js